/**
 * Aegix brand metadata + asset references (ADR 115 §7).
 *
 * Wire-format brand-key: `aegix`
 * User-visible display string: `Aegix`
 *
 * This is the default brand — Aegix-branded consumers (aim-web at
 * `aim.*`, sms-web at `sms.*`, Aegix One at `one.*`, Beacon at
 * `beacon.*`) and the resolver's fallback path land here.
 */

import logoUrl from './logo.svg';
import logoDarkUrl from './logo-dark.svg';
import faviconUrl from './favicon.ico';

import type { BrandAssets } from '../safe-plus';

export type { BrandAssets } from '../safe-plus';

export const AEGIX_ASSETS: BrandAssets = Object.freeze({
  displayName: 'Aegix',
  logoUrl,
  logoDarkUrl,
  faviconUrl,
});

export default AEGIX_ASSETS;
